export type ConsentChoice = 'necessary' | 'all';

const COOKIE_NAME = 'churnsignal_consent';
const SIX_MONTHS_SECONDS = 60 * 60 * 24 * 180;
const GTM_ID = 'GTM-NHDD9S6M';
const GA_ID = 'G-21BMJXY6QS';

declare global {
  interface Window {
    dataLayer?: unknown[];
  }
}

let analyticsLoaded = false;

export function readConsent(): ConsentChoice | null {
  const entry = document.cookie
    .split('; ')
    .find((part) => part.startsWith(`${COOKIE_NAME}=`));
  const value = entry?.slice(COOKIE_NAME.length + 1);
  if (value === 'necessary' || value === 'all') {
    return value;
  }
  return null;
}

export function writeConsent(choice: ConsentChoice) {
  const secure = window.location.protocol === 'https:' ? '; Secure' : '';
  document.cookie = `${COOKIE_NAME}=${choice}; Path=/; Max-Age=${SIX_MONTHS_SECONDS}; SameSite=Lax${secure}`;
}

export function loadAnalytics() {
  if (analyticsLoaded) {
    return;
  }
  analyticsLoaded = true;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ 'gtm.start': Date.now(), event: 'gtm.js' });

  const gtm = document.createElement('script');
  gtm.async = true;
  gtm.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`;
  document.head.appendChild(gtm);

  const ga = document.createElement('script');
  ga.async = true;
  ga.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(ga);

  function gtag(...args: unknown[]) {
    window.dataLayer?.push(args);
  }
  gtag('js', new Date());
  gtag('config', GA_ID);
}

export function clearAnalyticsCookies() {
  const names = document.cookie
    .split('; ')
    .map((part) => part.split('=')[0])
    .filter((name) => name === '_ga' || name === '_gid' || name.startsWith('_ga_') || name.startsWith('_gat'));

  const host = window.location.hostname;
  const domains = ['', host, host.includes('.') ? `.${host}` : ''];

  names.forEach((name) => {
    domains.forEach((domain) => {
      const domainAttr = domain ? `; Domain=${domain}` : '';
      document.cookie = `${name}=; Path=/; Max-Age=0; SameSite=Lax${domainAttr}`;
      document.cookie = `${name}=; Path=/; Expires=Thu, 01 Jan 1970 00:00:00 GMT${domainAttr}`;
    });
  });
}
